import { listSupply, createSupply, getSupply, updateSupply, createSupplyDocument, updateSupplyDocument, deleteSupplyDocument, searchSupply, getSupplyDetail } from './service/supply.service';

const state = {
	loading: false,
	supply: null,
	supplies: [],
	suppliesPagination: null,
	loadingSearch: false,
};

const mutations = {
	SET_LOADING(state, value) {
		state.loading = value;
	},
	SET_SUPPLY(state, value) {
		state.supply = value;
	},
	SET_SUPPLIES(state, value) {
		state.supplies = value || [];
	},
	SET_SUPPLIES_PAGINATION(state, value) {
		state.suppliesPagination = value || null;
	},
	SET_LOADING_SEARCH(state, value) {
		state.loadingSearch = value;
	},
};

const actions = {
	async listSupply({ commit }, params) {
		commit('SET_LOADING_SEARCH', true);
		commit('SET_SUPPLIES', []);
		commit('SET_SUPPLIES_PAGINATION', null);
		try {
			const response = await listSupply(params);
			commit('SET_SUPPLIES', response?.data || []);
			commit('SET_SUPPLIES_PAGINATION', response?.pagination || null);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING_SEARCH', false);
		}
	},

	async createSupply({ commit }, payload) {
		commit('SET_LOADING', true);
		try {
			const response = await createSupply(payload);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING', false);
		}
	},

	async updateSupply({ commit }, { id, payload }) {
		commit('SET_LOADING', true);
		try {
			const response = await updateSupply(id, payload);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING', false);
		}
	},

	async updateSupplyDocument({ commit }, { id, payload }) {
		commit('SET_LOADING', true);
		try {
			const response = await updateSupplyDocument(id, payload);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING', false);
		}
	},

	async deleteSupplyDocument(context, id) {
		try {
			const response = await deleteSupplyDocument(id);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		}
	},

	async createSupplyDocument({ commit }, payload) {
		commit('SET_LOADING', true);
		try {
			const response = await createSupplyDocument(payload);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING', false);
		}
	},

	async searchSupply({ commit }, params) {
		commit('SET_LOADING_SEARCH', true);
		commit('SET_SUPPLIES', []);
		commit('SET_SUPPLIES_PAGINATION', null);
		try {
			const response = await searchSupply(params);
			commit('SET_SUPPLIES', response?.data || []);
			commit('SET_SUPPLIES_PAGINATION', response?.pagination || null);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING_SEARCH', false);
		}
	},

	async getSupplyDetail(context, id) {
		try {
			const response = await getSupplyDetail(id);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		}
	},

	async getSupply({ commit }, id) {
		commit('SET_LOADING', true);
		try {
			const response = await getSupply(id);
			commit('SET_SUPPLY', response?.data || null);
			return { ok: true, response };
		} catch (error) {
			commit('SET_SUPPLY', null);
			return { ok: false, error: error?.response };
		} finally {
			commit('SET_LOADING', false);
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
